/** @jsxImportSource @emotion/react */
import React from "react";
import styled from "@emotion/styled";
import ResetIcon from "../../../img/butter_svgs/Reset.svg?react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { WrapQuoteStatus } from "../../../types/wrapQuote";
import { OrderStatus } from "../../../types/orderStatus";
import { CHAINS } from "config/chains";

export const WrappingQuoteHeader: React.FC = () => {
  const network = GlobalStore.useState(s => s.network);
  const wrapQuoteStatus = GlobalStore.useState(s => s.wrapQuoteStatus);
  const showResetIcon =
    wrapQuoteStatus === WrapQuoteStatus.FAILED_WRAP ||
    wrapQuoteStatus === WrapQuoteStatus.USER_REJECTED_WRAP;
  const selectedNetwork = CHAINS[network.id];
  const SelectedNetworkIcon = selectedNetwork.icon;

  const handleOnClick = () => {
    GlobalStore.update(s => {
      s.orderStatus = OrderStatus.ENTRY;
      s.wrapQuoteStatus = WrapQuoteStatus.PENDING_WALLET_CONFIRM;
    });
  };

  return (
    <ApprovalsHeaderContainer>
      <div>
        <StyledResetIcon onClick={handleOnClick} isVisible={showResetIcon} />
      </div>
      <div>
        <SelectedNetworkIcon color={selectedNetwork.iconColor} />
      </div>
    </ApprovalsHeaderContainer>
  );
};

const StyledResetIcon = styled(ResetIcon)<{ isVisible: boolean }>`
  cursor: pointer;
  color: ${props => props.theme.button.primary.surface.active};
  display: ${props => (props.isVisible ? "block" : "none")};
`;
export const ApprovalsHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 26px;
  padding-right: 26px;
`;
